import { useEffect, useState } from 'react';
import { api } from '../lib/api';
import { formatDateTime } from '../lib/format';

interface Bookmark {
  source_id: number;
  platform_message_id: string;
  handle: string;
  date_utc: string;
  permalink: string | null;
  text: string | null;
  media_path: string | null;
  saved_at: string;
  note: string | null;
}

export function BookmarksPage() {
  const [items, setItems] = useState<Bookmark[]>([]);
  const [error, setError] = useState<string | null>(null);

  const load = async () => {
    const data = await api.get<{ bookmarks: Bookmark[] }>('/api/bookmarks');
    setItems(data.bookmarks);
  };

  useEffect(() => {
    void load().catch((e) => setError(e instanceof Error ? e.message : 'Laden mislukt'));
  }, []);

  const remove = async (b: Bookmark) => {
    await api.delete('/api/bookmarks', {
      sourceId: b.source_id,
      platformMessageId: b.platform_message_id,
    });
    await load();
  };

  return (
    <div>
      <h1>Opgeslagen</h1>
      <p className="page-lead">Persoonlijke bookmarks — alleen zichtbaar voor jou.</p>
      {error && <div className="alert error">{error}</div>}
      {items.length === 0 && <div className="empty">Nog geen opgeslagen berichten.</div>}
      <div className="msg-list">
        {items.map((b) => (
          <article className="msg" key={`${b.source_id}-${b.platform_message_id}`}>
            <div className="msg-head">
              <span>
                {b.handle} · {formatDateTime(b.date_utc)}
              </span>
              <button className="btn btn-danger btn-sm" type="button" onClick={() => void remove(b)}>
                Verwijderen
              </button>
            </div>
            {b.permalink && (
              <a href={b.permalink} target="_blank" rel="noopener noreferrer">
                {b.permalink}
              </a>
            )}
            <pre className="msg-text">{b.text || '[Media]'}</pre>
          </article>
        ))}
      </div>
    </div>
  );
}
